import React, { useState } from "react";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { useProjectTaskDashboardContext } from "../context";
import { projectTaskListColumnsL } from "../responsiveData/project/gridColDefinitionL";
import { Typography } from "@mui/material";
import { DataGridDashboardWrapper } from "components/Wrappers/DataGrid/DataGridDashboardWrapper";

export const ProjectTaskListForDashboard = ({ pageName }) => {
  const { projectStatusList, setCurrentProject } =
    useProjectTaskDashboardContext();
  const [sortedRecords, setSortedRecords] = useState(projectStatusList);

  const handleTaskClick = (projectId) => {
    setCurrentProject(projectId);
  };
  return (
    <>
      <ToolbarThinWrapper />
      <Typography>{pageName}</Typography>
      <div style={{ width: "100%" }}>
        <DataGridDashboardWrapper
          getRowId={(options) => options.projectId}
          rows={sortedRecords}
          getRowHeight={() => "auto"}
          disableColumnMenu={true}
          columns={projectTaskListColumnsL({
            handleTaskClick,
            records: projectStatusList,
            setOutputRecords: setSortedRecords,
          })}
        />
      </div>
    </>
  );
};
